import { render } from "./Image.vue?vue&type=template&id=2b82ed60"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=2b82ed60&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__